<div style="text-align:center">
  <h1>
    QR Code Generation
  </h1>
</div>
<div class="center">
  <!-- <qrcode cssClass="aclass" correctionLevel="L" #parent [qrdata]="value" [width]="256" [errorCorrectionLevel]="'M'">
  </qrcode> -->
</div>
